export default __webpack_public_path__ + "static/media/back.949413a6.svg";